import { render } from "./ProfileInput.vue?vue&type=template&id=4ecb115f&scoped=true"
import script from "./ProfileInput.vue?vue&type=script&lang=js"
export * from "./ProfileInput.vue?vue&type=script&lang=js"

import "./ProfileInput.vue?vue&type=style&index=0&id=4ecb115f&scoped=true&lang=css"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecb115f"]])

export default __exports__